import { render, staticRenderFns } from "./PrefectureList.vue?vue&type=template&id=367bfb9c&scoped=true"
import script from "./PrefectureList.vue?vue&type=script&lang=js"
export * from "./PrefectureList.vue?vue&type=script&lang=js"
import style0 from "./PrefectureList.vue?vue&type=style&index=0&id=367bfb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367bfb9c",
  null
  
)

export default component.exports